(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var WISHLIST_KEY_PREFIX = 'ch-collection-wishlist-';

    class CHCollectionSliderElement extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      init() {
        this.track = this.querySelector('[data-ch-track]');
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-ch-item]'));
        this.prevBtn = this.querySelector('[data-ch-prev]');
        this.nextBtn = this.querySelector('[data-ch-next]');
        this.wishlistButtons = Array.prototype.slice.call(this.querySelectorAll('[data-ch-wishlist]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.restoreWishlist();
        this.updateArrowState();

        if (!this._bound) {
          this._bound = true;

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

          this.wishlistButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              this.toggleWishlist(button);
            });
          });

          var raf = null;
          if (this.track) {
            this.track.addEventListener(
              'scroll',
              () => {
                if (raf) return;
                raf = requestAnimationFrame(() => {
                  this.updateArrowState();
                  raf = null;
                });
              },
              { passive: true }
            );
          }

          window.addEventListener('resize', () => this.updateArrowState());
        }
      }

      step(direction) {
        var item = this.items[0];
        if (!item || !this.track) return;
        var gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
        var amount = (item.getBoundingClientRect().width + gap) * direction;
        this.track.scrollBy({ left: amount, behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }

      updateArrowState() {
        if (!this.track) return;
        var scrollLeft = this.track.scrollLeft;
        var maxScroll = this.track.scrollWidth - this.track.clientWidth;

        if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
        if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 1;
      }

      toggleWishlist(button) {
        var key = button.getAttribute('data-key');
        var isActive = !button.classList.contains('is-active');
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        try {
          window.localStorage.setItem(WISHLIST_KEY_PREFIX + key, isActive ? '1' : '0');
        } catch (e) {
          // localStorage unavailable - state stays in-memory only.
        }
      }

      restoreWishlist() {
        this.wishlistButtons.forEach((button) => {
          var key = button.getAttribute('data-key');
          var stored = null;
          try {
            stored = window.localStorage.getItem(WISHLIST_KEY_PREFIX + key);
          } catch (e) {
            stored = null;
          }
          var isActive = stored === '1';
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }
    }

    if (!customElements.get('ch-collection-slider')) {
      customElements.define('ch-collection-slider', CHCollectionSliderElement);
    }

    document.addEventListener('shopify:section:load', (event) => {
      var root = event.target.querySelector('ch-collection-slider');
      if (root && typeof root.init === 'function') root.init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class CollectionShowcaseElement extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      init() {
        this.track = this.querySelector('[data-cs-track]');
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-cs-card]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-cs-dot]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.observer) this.observer.disconnect();

        if ('IntersectionObserver' in window && this.cards.length) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const card = entry.target;
                const index = parseInt(card.getAttribute('data-index'), 10);
                const video = card.querySelector('video');

                if (entry.isIntersecting) {
                  if (entry.intersectionRatio > 0.6) {
                    this.setActiveDot(index);
                  }
                  if (video && video.paused) {
                    video.play().catch(() => {});
                  }
                } else if (video && !video.paused) {
                  video.pause();
                }
              });
            },
            { root: this.track, threshold: [0, 0.6, 1] }
          );

          this.cards.forEach((card) => this.observer.observe(card));
        }

        if (!this._bound) {
          this._bound = true;

          this.addEventListener('click', (event) => {
            const dot = event.target.closest ? event.target.closest('[data-cs-dot]') : null;
            if (!dot) return;
            this.goTo(parseInt(dot.getAttribute('data-index'), 10));
          });

          this.addEventListener('shopify:block:select', (event) => {
            const card = event.target.closest ? event.target.closest('[data-cs-card]') : null;
            if (card) this.scrollToCard(card);
          });
        }
      }

      goTo(index) {
        const card = this.cards[index];
        if (card) this.scrollToCard(card);
      }

      scrollToCard(card) {
        card.scrollIntoView({
          behavior: this.reduceMotion ? 'auto' : 'smooth',
          inline: 'start',
          block: 'nearest',
        });
      }

      setActiveDot(index) {
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
    }

    if (!customElements.get('collection-showcase')) {
      customElements.define('collection-showcase', CollectionShowcaseElement);
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('collection-showcase');
      if (root && typeof root.init === 'function') root.init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FAVORITE_KEY_PREFIX = 'fcs-favorite-';

    class FeaturedCollectionSliderElement extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mediaObserver) this.mediaObserver.disconnect();
        if (this.revealObserver) this.revealObserver.disconnect();
      }

      init() {
        this.track = this.querySelector('[data-fcs-track]');
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-fcs-card]'));
        this.prevBtn = this.querySelector('[data-fcs-prev]');
        this.nextBtn = this.querySelector('[data-fcs-next]');
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-fcs-dot]'));
        this.favorites = Array.prototype.slice.call(this.querySelectorAll('[data-fcs-favorite]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.restoreFavorites();
        this.updateArrowState();
        this.setupObserver();
        this.setupArrowPosition();
        this.setupReveal();

        if (!this._bound) {
          this._bound = true;

          if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => this.step(-1));
          }
          if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => this.step(1));
          }

          this.favorites.forEach((button) => {
            button.addEventListener('click', () => this.toggleFavorite(button));
          });

          this.addEventListener('click', (event) => {
            var dot = event.target.closest ? event.target.closest('[data-fcs-dot]') : null;
            if (dot) this.goToCard(parseInt(dot.getAttribute('data-index'), 10));
          });

          this.addEventListener('keydown', (event) => {
            var card = event.target.closest ? event.target.closest('[data-fcs-card]') : null;
            if (!card) return;
            var index = parseInt(card.getAttribute('data-index'), 10);
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.focusCard(index + 1);
            } else if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.focusCard(index - 1);
            }
          });

          var raf = null;
          this.track.addEventListener('scroll', () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              this.updateArrowState();
              raf = null;
            });
          }, { passive: true });

          window.addEventListener('resize', () => this.updateArrowState());
        }
      }

      step(direction) {
        var card = this.cards[0];
        if (!card) return;
        var gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
        var amount = (card.getBoundingClientRect().width + gap) * direction;
        this.track.scrollBy({ left: amount, behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }

      goToCard(index) {
        var card = this.cards[index];
        if (card) {
          card.scrollIntoView({
            behavior: this.reduceMotion ? 'auto' : 'smooth',
            inline: 'start',
            block: 'nearest',
          });
        }
      }

      focusCard(index) {
        var card = this.cards[index];
        if (!card) return;
        card.focus();
        this.goToCard(index);
      }

      updateArrowState() {
        if (!this.track) return;
        var scrollLeft = this.track.scrollLeft;
        var maxScroll = this.track.scrollWidth - this.track.clientWidth;

        if (this.prevBtn) {
          this.prevBtn.disabled = scrollLeft <= 1;
        }
        if (this.nextBtn) {
          this.nextBtn.disabled = scrollLeft >= maxScroll - 1;
        }
      }

      setupArrowPosition() {
        if (!this.prevBtn && !this.nextBtn) return;
        var media = this.cards[0] && this.cards[0].querySelector('.fcs-card__media');
        if (!media) return;

        var updatePosition = () => {
          var center = media.offsetTop + media.offsetHeight / 2;
          if (this.prevBtn) this.prevBtn.style.top = center + 'px';
          if (this.nextBtn) this.nextBtn.style.top = center + 'px';
        };

        updatePosition();

        if (this.mediaObserver) this.mediaObserver.disconnect();
        if ('ResizeObserver' in window) {
          this.mediaObserver = new ResizeObserver(updatePosition);
          this.mediaObserver.observe(media);
        } else {
          window.addEventListener('resize', updatePosition);
        }
      }

      setupReveal() {
        if (this.revealObserver) this.revealObserver.disconnect();

        if (this.reduceMotion) {
          this.cards.forEach((card) => card.classList.add('is-visible'));
          return;
        }

        if (!('IntersectionObserver' in window) || !this.cards.length) {
          this.cards.forEach((card) => card.classList.add('is-visible'));
          return;
        }

        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              var card = entry.target;
              var index = parseInt(card.getAttribute('data-index'), 10) || 0;
              card.style.setProperty('--fcs-reveal-delay', (Math.min(index, 8) * 100) + 'ms');
              card.classList.add('is-visible');
              this.revealObserver.unobserve(card);
            });
          },
          { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
        );

        this.cards.forEach((card) => this.revealObserver.observe(card));
      }

      setupObserver() {
        if (this.observer) this.observer.disconnect();
        if (!('IntersectionObserver' in window) || !this.cards.length) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                var index = parseInt(entry.target.getAttribute('data-index'), 10);
                this.setActiveDot(index);
              }
            });
          },
          { root: this.track, threshold: [0, 0.6, 1] }
        );

        this.cards.forEach((card) => this.observer.observe(card));
      }

      setActiveDot(index) {
        this.dots.forEach((dot, i) => {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      // Front-end only wishlist toggle. Persists to localStorage as a placeholder
      // hook until a real wishlist app is wired up to replace this behavior.
      toggleFavorite(button) {
        var productId = button.getAttribute('data-product-id');
        var isActive = !button.classList.contains('is-active');
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        try {
          window.localStorage.setItem(FAVORITE_KEY_PREFIX + productId, isActive ? '1' : '0');
        } catch (e) {
          // localStorage unavailable (private browsing, etc.) - state stays in-memory only.
        }
      }

      restoreFavorites() {
        this.favorites.forEach((button) => {
          var productId = button.getAttribute('data-product-id');
          var stored;
          try {
            stored = window.localStorage.getItem(FAVORITE_KEY_PREFIX + productId);
          } catch (e) {
            stored = null;
          }
          var isActive = stored === '1';
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }
    }

    if (!customElements.get('featured-collection-slider')) {
      customElements.define('featured-collection-slider', FeaturedCollectionSliderElement);
    }

    function initHeaderReveal(scope) {
      var headers = Array.prototype.slice.call((scope || document).querySelectorAll('.fcs-header:not([data-reveal-bound])'));
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      headers.forEach(function (header) {
        header.setAttribute('data-reveal-bound', 'true');

        if (reduceMotion || !('IntersectionObserver' in window)) {
          header.classList.add('is-visible');
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
        );
        observer.observe(header);
      });
    }

    initHeaderReveal();

    document.addEventListener('shopify:section:load', (event) => {
      var root = event.target.querySelector('featured-collection-slider');
      if (root && typeof root.init === 'function') root.init();
      initHeaderReveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterAccordion {
    constructor() {
      this.init();
    }

    init() {
      document.addEventListener('click', this.onClick.bind(this));
      
      this.wasDesktop = window.matchMedia('(min-width: 990px)').matches;
      window.addEventListener('resize', this.onResize.bind(this));
      
      this.fixDesktopState();
      document.addEventListener('shopify:section:load', this.fixDesktopState.bind(this));
    }

    fixDesktopState() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        document.querySelectorAll('[data-accordion="true"]').forEach((footer) => {
          footer.querySelectorAll('[data-menu-toggle]').forEach((toggle) => {
            toggle.setAttribute('aria-expanded', 'true');
            const list = document.getElementById(toggle.getAttribute('aria-controls'));
            if (list) list.removeAttribute('hidden');
          });
        });
      }
    }

    onResize() {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (isDesktop !== this.wasDesktop) {
        document.querySelectorAll('[data-accordion="true"]').forEach((footer) => {
          footer.querySelectorAll('[data-menu-toggle]').forEach((toggle) => {
            const list = document.getElementById(toggle.getAttribute('aria-controls'));
            if (isDesktop) {
              toggle.setAttribute('aria-expanded', 'true');
              if (list) list.removeAttribute('hidden');
            } else {
              toggle.setAttribute('aria-expanded', 'false');
              if (list) list.setAttribute('hidden', '');
            }
          });
        });
        this.wasDesktop = isDesktop;
      }
    }

    onClick(event) {
      const toggle = event.target.closest('[data-accordion="true"] [data-menu-toggle]');
      if (!toggle) return;
      if (window.matchMedia('(min-width: 990px)').matches) return;

      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const list = document.getElementById(toggle.getAttribute('aria-controls'));

      if (!expanded) {
        const footer = toggle.closest('[data-accordion="true"]');
        if (footer) {
          footer.querySelectorAll('[data-menu-toggle]').forEach((otherToggle) => {
            if (otherToggle !== toggle) {
              otherToggle.setAttribute('aria-expanded', 'false');
              const otherList = document.getElementById(otherToggle.getAttribute('aria-controls'));
              if (otherList) otherList.setAttribute('hidden', '');
            }
          });
        }
      }

      toggle.setAttribute('aria-expanded', String(!expanded));
      if (list) {
        if (expanded) {
          list.setAttribute('hidden', '');
        } else {
          list.removeAttribute('hidden');
        }
      }
    }
  }

  if (typeof window.footerAccordionInitialized === 'undefined') {
    window.footerAccordionInitialized = true;
    new FooterAccordion();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript ? document.currentScript.closest('.shopify-section') : document;

    function qs(sel, ctx) {
      return (ctx || root || document).querySelector(sel);
    }
    function qsa(sel, ctx) {
      return Array.prototype.slice.call((ctx || root || document).querySelectorAll(sel));
    }

    /* Sticky header shadow */
    var headerEl = qs('.lux-header');
    if (headerEl && headerEl.dataset.sticky === 'true') {
      var toggleStuck = function () {
        if (window.scrollY > 4) {
          headerEl.classList.add('is-stuck');
        } else {
          headerEl.classList.remove('is-stuck');
        }
      };
      window.addEventListener('scroll', toggleStuck, { passive: true });
      toggleStuck();
    }

    /* Announcement slider */
    var announcement = qs('[data-announcement]');
    if (announcement) {
      var slides = qsa('[data-announcement-slide]', announcement);
      var prevBtn = qs('[data-announcement-prev]', announcement);
      var nextBtn = qs('[data-announcement-next]', announcement);
      var speed = parseInt(announcement.dataset.speed, 10) || 5000;
      var index = 0;
      var timer = null;

      function show(i) {
        slides.forEach(function (slide, si) {
          slide.classList.toggle('is-active', si === i);
        });
        index = i;
      }

      function next() {
        show((index + 1) % slides.length);
      }

      function prev() {
        show((index - 1 + slides.length) % slides.length);
      }

      function restart() {
        if (timer) clearInterval(timer);
        if (slides.length > 1) {
          timer = setInterval(next, speed);
        }
      }

      if (slides.length > 1) {
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            next();
            restart();
          });
        }
        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            prev();
            restart();
          });
        }
        restart();
      }
    }

    /* Search panel */
    var searchOpenBtn = qs('[data-search-open]');
    var searchPanel = qs('[data-search-panel]');
    var searchCloseBtn = qs('[data-search-close]');
    var searchInput = qs('[data-search-input]');

    function openSearch() {
      if (!searchPanel) return;
      searchPanel.hidden = false;
      searchOpenBtn.setAttribute('aria-expanded', 'true');
      if (searchInput) searchInput.focus();
    }

    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.hidden = true;
      searchOpenBtn.setAttribute('aria-expanded', 'false');
    }

    if (searchOpenBtn) {
      searchOpenBtn.addEventListener('click', function () {
        if (searchPanel.hidden) openSearch();
        else closeSearch();
      });
    }
    if (searchCloseBtn) {
      searchCloseBtn.addEventListener('click', closeSearch);
    }

    /* Desktop mega menu */
    var navItems = qsa('[data-nav-item]');
    navItems.forEach(function (item) {
      var trigger = qs('[data-nav-trigger]', item);
      var closeTimer = null;

      function openItem() {
        clearTimeout(closeTimer);
        navItems.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var otherTrigger = qs('[data-nav-trigger]', other);
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }

      function closeItem() {
        item.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }

      function scheduleClose() {
        closeTimer = setTimeout(closeItem, 150);
      }

      item.addEventListener('mouseenter', openItem);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', openItem);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeItem();
      });
    });

    /* Escape closes everything */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      navItems.forEach(function (item) {
        item.classList.remove('is-open');
        var t = qs('[data-nav-trigger]', item);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      closeSearch();
      closeDrawer();
    });

    /* Mobile drawer — full width, positioned below the still-visible header row */
    var drawer = qs('[data-drawer]');
    var drawerOpenBtn = qs('[data-drawer-open]');
    var lastFocused = null;

    function trapFocus(e) {
      if (!drawer.classList.contains('is-open')) return;
      var focusable = qsa(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])',
        drawer
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function openDrawer() {
      if (!drawer) return;
      lastFocused = document.activeElement;
      if (headerEl) {
        drawer.style.top = headerEl.getBoundingClientRect().bottom + 'px';
      }
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      document.body.classList.add('lux-scroll-lock');
      drawerOpenBtn.setAttribute('aria-expanded', 'true');
      drawerOpenBtn.classList.add('is-active');
      document.addEventListener('keydown', trapFocus);
      var firstFocusable = qs('a[href], button:not([disabled])', drawer);
      if (firstFocusable) firstFocusable.focus();
    }

    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('lux-scroll-lock');
      drawerOpenBtn.setAttribute('aria-expanded', 'false');
      drawerOpenBtn.classList.remove('is-active');
      document.removeEventListener('keydown', trapFocus);
      setTimeout(function () {
        drawer.hidden = true;
      }, 250);
      if (lastFocused) lastFocused.focus();
    }

    if (drawerOpenBtn) {
      drawerOpenBtn.addEventListener('click', function () {
        if (drawer.hidden) openDrawer();
        else closeDrawer();
      });
    }

    /* Drawer accordion — auto-close siblings (mobile only) */
    qsa('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.nextElementSibling;
        var expanded = trigger.getAttribute('aria-expanded') === 'true';

        /* Close all sibling accordion items at the same level */
        if (!expanded) {
          var parentList = trigger.closest('.lux-accordion__item');
          var container = parentList ? parentList.parentElement : null;
          if (container) {
            qsa('[data-accordion-trigger]', container).forEach(function (otherTrigger) {
              /* Only close direct siblings, not nested children */
              if (otherTrigger !== trigger && otherTrigger.closest('.lux-accordion__item').parentElement === container) {
                var otherPanel = otherTrigger.nextElementSibling;
                otherTrigger.setAttribute('aria-expanded', 'false');
                if (otherPanel) otherPanel.hidden = true;

                /* Also close any nested accordions inside the sibling */
                if (otherPanel) {
                  qsa('[data-accordion-trigger]', otherPanel).forEach(function (nested) {
                    nested.setAttribute('aria-expanded', 'false');
                    var nestedPanel = nested.nextElementSibling;
                    if (nestedPanel) nestedPanel.hidden = true;
                  });
                }
              }
            });
          }
        }

        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.hidden = expanded;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luvcut-featured-heirloom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class FeaturedHeirloomPieces extends HTMLElement {
      connectedCallback() {
        this._findSection();
        this._bindEvents();
      }

      _findSection() {
        this._section = this.closest('.lfhp');
      }

      _bindEvents() {
        if (this._bound) return;
        this._bound = true;

        if (this._section) {
          this._section.addEventListener('click', (e) => {
            const tab = e.target.closest('[data-lfhp-tab]');
            if (tab) this._activate(tab.dataset.lfhpTab);
          });
        }

        /* Theme-editor: clicking a block scrolls its panel into view */
        this.addEventListener('shopify:block:select', (e) => {
          const panel = e.target.closest('[data-lfhp-panel]');
          if (panel) {
            this._activate(panel.dataset.lfhpPanel);
            panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      }

      _activate(index) {
        const tabs   = this._section
          ? Array.from(this._section.querySelectorAll('[data-lfhp-tab]'))
          : [];
        const panels = Array.from(this.querySelectorAll('[data-lfhp-panel]'));

        tabs.forEach((t) => {
          const active = t.dataset.lfhpTab === String(index);
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', String(active));
        });

        panels.forEach((p) => {
          const active = p.dataset.lfhpPanel === String(index);
          p.hidden = !active;
        });
      }
    }

    if (!customElements.get('featured-heirloom-pieces')) {
      customElements.define('featured-heirloom-pieces', FeaturedHeirloomPieces);
    }

    /* Re-initialise after theme editor section reload */
    document.addEventListener('shopify:section:load', (e) => {
      const el = e.target.querySelector('featured-heirloom-pieces');
      if (el) {
        el._bound = false;
        el.connectedCallback();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FAVORITE_KEY_PREFIX = 'cpg-favorite-';

    class CollectionProductGridElement extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      init() {
        this.grid = this.querySelector('[data-cpg-grid]');
        this.status = this.querySelector('[data-cpg-status]');
        this.paginationStyle = this.getAttribute('data-pagination-style');
        this.isLoading = false;

        this.bindFavorites();
        this.bindSwipes();
        this.bindLoadMore();
        this.bindInfiniteScroll();
        this.bindSort();
        this.bindFilters();
      }

      bindFilters() {
        var toggle = this.querySelector('[data-cpg-filters-toggle]');
        var drawer = this.querySelector('[data-cpg-filters-drawer]');
        var backdrop = this.querySelector('[data-cpg-filters-backdrop]');
        var closeBtn = this.querySelector('[data-cpg-filters-close]');
        var applyBtn = this.querySelector('[data-cpg-filters-apply]');
        var clearBtn = this.querySelector('[data-cpg-filters-clear]');
        if (!toggle || !drawer || drawer._cpgBound) return;
        drawer._cpgBound = true;

        var pendingParams = new URLSearchParams(window.location.search);

        var open = () => {
          drawer.classList.add('is-open');
          if (backdrop) backdrop.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
        };

        var close = () => {
          drawer.classList.remove('is-open');
          if (backdrop) backdrop.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        };

        toggle.addEventListener('click', () => {
          pendingParams = new URLSearchParams(window.location.search);
          open();
        });

        if (backdrop) backdrop.addEventListener('click', close);
        if (closeBtn) closeBtn.addEventListener('click', close);

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
        });

        this.querySelectorAll('[data-cpg-filter-chip]').forEach((chip) => {
          chip.addEventListener('click', () => {
            var name = chip.getAttribute('data-param-name');
            var value = chip.getAttribute('data-param-value');
            var willActivate = !chip.classList.contains('is-active');

            var existing = pendingParams.getAll(name).filter((v) => v !== value);
            pendingParams.delete(name);
            existing.forEach((v) => pendingParams.append(name, v));
            if (willActivate) pendingParams.append(name, value);

            chip.classList.toggle('is-active', willActivate);
            chip.setAttribute('aria-pressed', willActivate ? 'true' : 'false');
          });
        });

        var priceSlider = this.querySelector('[data-cpg-price-slider]');
        if (priceSlider) {
          var minInput = priceSlider.querySelector('[data-cpg-price-min]');
          var maxInput = priceSlider.querySelector('[data-cpg-price-max]');
          var minLabel = this.querySelector('[data-cpg-price-min-label]');
          var maxLabel = this.querySelector('[data-cpg-price-max-label]');
          var minParam = priceSlider.getAttribute('data-min-param');
          var maxParam = priceSlider.getAttribute('data-max-param');

          var formatMoney = (value) => {
            try {
              return Shopify && Shopify.formatMoney
                ? Shopify.formatMoney(value * 100)
                : value;
            } catch (e) {
              return value;
            }
          };

          var syncPrice = () => {
            var minVal = parseFloat(minInput.value);
            var maxVal = parseFloat(maxInput.value);
            if (minVal > maxVal) {
              var temp = minVal;
              minVal = maxVal;
              maxVal = temp;
            }
            if (minLabel) minLabel.textContent = formatMoney(minVal);
            if (maxLabel) maxLabel.textContent = formatMoney(maxVal);
            pendingParams.set(minParam, minVal);
            pendingParams.set(maxParam, maxVal);
          };

          if (minInput) minInput.addEventListener('input', syncPrice);
          if (maxInput) maxInput.addEventListener('input', syncPrice);
        }

        if (applyBtn) {
          applyBtn.addEventListener('click', () => {
            var url = new URL(window.location.href);
            url.search = pendingParams.toString();
            url.searchParams.delete('page');
            window.location.href = url.toString();
          });
        }

        if (clearBtn) {
          clearBtn.addEventListener('click', () => {
            var url = new URL(window.location.href);
            var keep = new URLSearchParams();
            var sortValue = url.searchParams.get('sort_by');
            if (sortValue) keep.set('sort_by', sortValue);
            url.search = keep.toString();
            window.location.href = url.toString();
          });
        }
      }

      bindSort() {
        var wrap = this.querySelector('.cpg-sort');
        var toggle = this.querySelector('[data-cpg-sort-toggle]');
        var panel = this.querySelector('[data-cpg-sort-panel]');
        if (!wrap || !toggle || !panel || wrap._cpgBound) return;
        wrap._cpgBound = true;

        var close = () => {
          panel.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        };

        toggle.addEventListener('click', (event) => {
          event.stopPropagation();
          var willOpen = !panel.classList.contains('is-open');
          panel.classList.toggle('is-open', willOpen);
          toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });

        panel.addEventListener('click', (event) => {
          var option = event.target.closest('[data-cpg-sort-option]');
          if (!option) return;
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', option.getAttribute('data-value'));
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });

        document.addEventListener('click', (event) => {
          if (!wrap.contains(event.target)) close();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') close();
        });
      }

      bindFavorites() {
        var favorites = Array.prototype.slice.call(this.querySelectorAll('[data-cpg-favorite]'));
        favorites.forEach((button) => {
          if (button._cpgBound) return;
          button._cpgBound = true;

          var productId = button.getAttribute('data-product-id');
          var stored;
          try {
            stored = window.localStorage.getItem(FAVORITE_KEY_PREFIX + productId);
          } catch (e) {
            stored = null;
          }
          var isActive = stored === '1';
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

          button.addEventListener('click', (event) => {
            event.preventDefault();
            var active = !button.classList.contains('is-active');
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
            try {
              window.localStorage.setItem(FAVORITE_KEY_PREFIX + productId, active ? '1' : '0');
            } catch (e) {
              // localStorage unavailable - state stays in-memory only.
            }
          });
        });
      }

      bindSwipes() {
        var swipes = Array.prototype.slice.call(this.querySelectorAll('[data-cpg-swipe]'));
        swipes.forEach((swipe) => {
          if (swipe._cpgBound) return;
          swipe._cpgBound = true;

          var track = swipe.querySelector('[data-cpg-swipe-track]');
          var card = swipe.closest('[data-cpg-card]');
          var dots = card ? Array.prototype.slice.call(card.querySelectorAll('[data-cpg-swipe-dot]')) : [];
          if (!track || !dots.length) return;

          var raf = null;
          track.addEventListener('scroll', () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              var index = Math.round(track.scrollLeft / track.clientWidth);
              dots.forEach((dot, i) => {
                var active = i === index;
                dot.classList.toggle('is-active', active);
                dot.setAttribute('aria-current', active ? 'true' : 'false');
              });
              raf = null;
            });
          }, { passive: true });

          dots.forEach((dot) => {
            dot.addEventListener('click', (event) => {
              event.preventDefault();
              var index = parseInt(dot.getAttribute('data-index'), 10) || 0;
              track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
            });
          });
        });
      }

      bindLoadMore() {
        var button = this.querySelector('[data-cpg-load-more]');
        if (!button || button._cpgBound) return;
        button._cpgBound = true;

        button.addEventListener('click', () => {
          this.loadNextPage(button.getAttribute('data-next-url'), () => button.closest('.cpg-load-more-wrapper'));
        });
      }

      bindInfiniteScroll() {
        var sentinel = this.querySelector('[data-cpg-sentinel]');
        if (!sentinel || sentinel._cpgBound) return;
        sentinel._cpgBound = true;

        if (!('IntersectionObserver' in window)) return;

        this.infiniteObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isLoading) {
              this.loadNextPage(sentinel.getAttribute('data-next-url'), () => sentinel);
            }
          });
        }, { rootMargin: '400px' });

        this.infiniteObserver.observe(sentinel);
      }

      loadNextPage(url, getControl) {
        if (!url || this.isLoading) return;
        this.isLoading = true;

        var control = getControl();
        if (control && control.tagName === 'BUTTON') {
          control.setAttribute('aria-busy', 'true');
          control.disabled = true;
        }

        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.getElementById(this.grid.id);
            var newControlWrapper = doc.querySelector('[data-cpg-load-more], [data-cpg-sentinel]');

            if (newGrid) {
              var items = Array.prototype.slice.call(newGrid.children);
              items.forEach((item) => this.grid.appendChild(item));
              if (this.status) {
                this.status.textContent = 'Loaded ' + items.length + ' more products.';
              }
            }

            if (this.paginationStyle === 'load_more') {
              var wrapper = this.querySelector('.cpg-load-more-wrapper');
              if (wrapper) {
                if (newControlWrapper) {
                  wrapper.replaceWith(newControlWrapper.closest('.cpg-load-more-wrapper') || newControlWrapper);
                  this.bindLoadMore();
                } else {
                  wrapper.remove();
                }
              }
            } else if (this.paginationStyle === 'infinite_scroll') {
              var sentinel = this.querySelector('[data-cpg-sentinel]');
              if (sentinel) {
                if (newControlWrapper && newControlWrapper.hasAttribute('data-cpg-sentinel')) {
                  sentinel.setAttribute('data-next-url', newControlWrapper.getAttribute('data-next-url'));
                } else {
                  if (this.infiniteObserver) this.infiniteObserver.unobserve(sentinel);
                  sentinel.remove();
                }
              }
            }

            this.bindFavorites();
            this.bindSwipes();
          })
          .catch(() => {
            if (this.status) this.status.textContent = 'Could not load more products.';
          })
          .finally(() => {
            this.isLoading = false;
            if (control && control.tagName === 'BUTTON') {
              control.removeAttribute('aria-busy');
              control.disabled = false;
            } else if (control && control.hasAttribute('data-cpg-sentinel')) {
              if (this.infiniteObserver && document.body.contains(control)) {
                this.infiniteObserver.unobserve(control);
                requestAnimationFrame(() => {
                  if (this.infiniteObserver && document.body.contains(control)) {
                    this.infiniteObserver.observe(control);
                  }
                });
              }
            }
          });
      }
    }

    if (!customElements.get('collection-product-grid')) {
      customElements.define('collection-product-grid', CollectionProductGridElement);
    }

    document.addEventListener('shopify:section:load', (event) => {
      var root = event.target.querySelector('collection-product-grid');
      if (root && typeof root.init === 'function') root.init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (function () {
    var FAVORITE_KEY_PREFIX = 'cpg-favorite-';

    class RelatedProductsGridElement extends HTMLElement {
      connectedCallback() {
        this.bindFavorites();
        this.bindSwipes();
      }

      bindFavorites() {
        var favorites = Array.prototype.slice.call(this.querySelectorAll('[data-cpg-favorite]'));
        favorites.forEach((button) => {
          if (button._cpgBound) return;
          button._cpgBound = true;

          var productId = button.getAttribute('data-product-id');
          var stored;
          try {
            stored = window.localStorage.getItem(FAVORITE_KEY_PREFIX + productId);
          } catch (e) {
            stored = null;
          }
          var isActive = stored === '1';
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

          button.addEventListener('click', (event) => {
            event.preventDefault();
            var active = !button.classList.contains('is-active');
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
            try {
              window.localStorage.setItem(FAVORITE_KEY_PREFIX + productId, active ? '1' : '0');
            } catch (e) {
              // localStorage unavailable - state stays in-memory only.
            }
          });
        });
      }

      bindSwipes() {
        var swipes = Array.prototype.slice.call(this.querySelectorAll('[data-cpg-swipe]'));
        swipes.forEach((swipe) => {
          if (swipe._cpgBound) return;
          swipe._cpgBound = true;

          var track = swipe.querySelector('[data-cpg-swipe-track]');
          var card = swipe.closest('[data-cpg-card]');
          var dots = card ? Array.prototype.slice.call(card.querySelectorAll('[data-cpg-swipe-dot]')) : [];
          if (!track || !dots.length) return;

          var raf = null;
          track.addEventListener('scroll', () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              var index = Math.round(track.scrollLeft / track.clientWidth);
              dots.forEach((dot, i) => {
                var active = i === index;
                dot.classList.toggle('is-active', active);
                dot.setAttribute('aria-current', active ? 'true' : 'false');
              });
              raf = null;
            });
          }, { passive: true });

          dots.forEach((dot) => {
            dot.addEventListener('click', (event) => {
              event.preventDefault();
              var index = parseInt(dot.getAttribute('data-index'), 10) || 0;
              track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
            });
          });
        });
      }
    }

    if (!customElements.get('related-products-grid')) {
      customElements.define('related-products-grid', RelatedProductsGridElement);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-diamond-shape"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_BP = 749;

    class ShopByDiamondShapeElement extends HTMLElement {
      connectedCallback() { this.init(); }

      disconnectedCallback() {
        this.teardownDrag();
        if (this.rmMedia) this.rmMedia.removeEventListener('change', this._onRM);
        if (this.revealObs) this.revealObs.disconnect();
      }

      init() {
        this.track    = this.querySelector('[data-sbds-track]');
        this.cards    = Array.prototype.slice.call(this.querySelectorAll('[data-sbds-card]'));
        this.prevBtn  = this.querySelector('[data-sbds-prev]');
        this.nextBtn  = this.querySelector('[data-sbds-next]');
        this.enableDrag = this.getAttribute('data-enable-drag') === 'true';

        this.rmMedia  = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._onRM    = () => this.applyRM();
        this.rmMedia.addEventListener('change', this._onRM);
        this.applyRM();

        this.setupReveal();
        this.updateArrows();

        if (!this._bound) {
          this._bound = true;

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

          this.addEventListener('keydown', (e) => {
            var card = e.target.closest ? e.target.closest('[data-sbds-card]') : null;
            if (!card) return;
            var idx = parseInt(card.getAttribute('data-index'), 10);
            if (e.key === 'ArrowRight') { e.preventDefault(); this.focusCard(idx + 1); }
            if (e.key === 'ArrowLeft')  { e.preventDefault(); this.focusCard(idx - 1); }
          });

          var raf = null;
          this.track.addEventListener('scroll', () => {
            if (raf) return;
            raf = requestAnimationFrame(() => { this.updateArrows(); raf = null; });
          }, { passive: true });

          window.addEventListener('resize', () => this.updateArrows());
          this.setupDrag();
        }
      }

      isMobile() { return window.innerWidth <= MOBILE_BP; }

      applyRM() {}  // no video in this section

      setupReveal() {
        if (this.revealObs) this.revealObs.disconnect();

        if (this.rmMedia.matches || !('IntersectionObserver' in window) || !this.cards.length) {
          this.cards.forEach(c => c.classList.add('is-visible'));
          return;
        }

        this.revealObs = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            var card = entry.target;
            var idx  = parseInt(card.getAttribute('data-index'), 10) || 0;
            card.style.setProperty('--sbds-reveal-delay', (Math.min(idx, 9) * 80) + 'ms');
            card.classList.add('is-visible');
            this.revealObs.unobserve(card);
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

        this.cards.forEach(c => this.revealObs.observe(c));
      }

      step(dir) {
        if (this.isMobile()) return;
        var card = this.cards[0];
        if (!card) return;
        var gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
        this.track.scrollBy({
          left: (card.getBoundingClientRect().width + gap) * dir,
          behavior: this.rmMedia.matches ? 'auto' : 'smooth'
        });
      }

      focusCard(idx) {
        var card = this.cards[idx];
        if (!card) return;
        card.focus();
        card.scrollIntoView({ behavior: this.rmMedia.matches ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
      }

      updateArrows() {
        if (!this.track) return;
        if (this.isMobile()) {
          if (this.prevBtn) this.prevBtn.disabled = true;
          if (this.nextBtn) this.nextBtn.disabled = true;
          return;
        }
        var sl  = this.track.scrollLeft;
        var max = this.track.scrollWidth - this.track.clientWidth;
        if (this.prevBtn) this.prevBtn.disabled = sl <= 1;
        if (this.nextBtn) this.nextBtn.disabled = sl >= max - 1;
      }

      setupDrag() {
        if (!this.enableDrag || !this.track) return;
        var isDown = false, startX = 0, startScroll = 0, moved = false;

        var onDown  = (e) => { if (this.isMobile()) return; isDown = true; moved = false; startX = e.clientX; startScroll = this.track.scrollLeft; this.track.classList.add('is-dragging'); };
        var onMove  = (e) => { if (!isDown) return; var d = e.clientX - startX; if (Math.abs(d) > 3) moved = true; this.track.scrollLeft = startScroll - d; };
        var endDrag = ()  => { if (!isDown) return; isDown = false; this.track.classList.remove('is-dragging'); };

        this.track.addEventListener('pointerdown',  onDown);
        this.track.addEventListener('pointermove',  onMove);
        this.track.addEventListener('pointerup',    endDrag);
        this.track.addEventListener('pointerleave', endDrag);
        this.track.addEventListener('pointercancel',endDrag);
        this.track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

        this._teardownDrag = () => {
          this.track.removeEventListener('pointerdown',  onDown);
          this.track.removeEventListener('pointermove',  onMove);
          this.track.removeEventListener('pointerup',    endDrag);
          this.track.removeEventListener('pointerleave', endDrag);
          this.track.removeEventListener('pointercancel',endDrag);
        };
      }

      teardownDrag() { if (this._teardownDrag) this._teardownDrag(); }
    }

    if (!customElements.get('shop-by-diamond-shape')) {
      customElements.define('shop-by-diamond-shape', ShopByDiamondShapeElement);
    }

    function initHeaderReveal(scope) {
      var headers = Array.prototype.slice.call((scope || document).querySelectorAll('.sbds-header:not([data-reveal-bound])'));
      var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      headers.forEach(function (header) {
        header.setAttribute('data-reveal-bound', 'true');
        if (rm || !('IntersectionObserver' in window)) { header.classList.add('is-visible'); return; }
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
          });
        }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
        obs.observe(header);
      });
    }

    initHeaderReveal();

    document.addEventListener('shopify:section:load', (e) => {
      var root = e.target.querySelector('shop-by-diamond-shape');
      if (root && typeof root.init === 'function') root.init();
      initHeaderReveal(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
